function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

/**
 * OAuth authorization view, redirects based on requested OAuth actions.
 */
import AuthErrors from '../lib/auth-errors';
import BaseView from './base';
import Cocktail from 'cocktail';
import ErrorRedirectMixin from './mixins/error-redirect-mixin';
import OAuthErrors from '../lib/oauth-errors';
import OAuthPrompt from '../lib/oauth-prompt';
import SignInMixin from './mixins/signin-mixin';

let AuthorizationView = /*#__PURE__*/function (_BaseView) {
  _inherits(AuthorizationView, _BaseView);

  var _super = _createSuper(AuthorizationView);

  function AuthorizationView() {
    _classCallCheck(this, AuthorizationView);

    return _super.apply(this, arguments);
  }

  _createClass(AuthorizationView, [{
    key: "beforeRender",
    value: function beforeRender() {
      if (this.relier.get('prompt') === OAuthPrompt.NONE) {
        return this._doPromptNone() // false prevents the view from rendering
        .then(() => false);
      }

      const action = this.relier.get('action');

      if (action) {
        const pathname = action === 'email' ? '/oauth/' : action;
        this.replaceCurrentPage(pathname);
      } else {
        // if no action is specified, let oauth-index decide based on
        // current user signed in state.
        this.replaceCurrentPage('/oauth/');
      }
    }
  }, {
    key: "_doPromptNone",
    value: function _doPromptNone() {
      const account = this.getSignedInAccount();
      return this.relier.validatePromptNoneRequest(account).then(() => this.signIn(account, null)) // Both validatePromptNoneRequest and signIn can
      // reject, .catch handles both cases.
      .catch(err => {
        const normalizedErr = this._normalizePromptNoneError(err);

        return this._handlePromptNoneError(normalizedErr);
      });
    }
  }, {
    key: "_normalizePromptNoneError",
    value: function _normalizePromptNoneError(err) {
      if (AuthErrors.is(err, 'INVALID_TOKEN')) {
        err = OAuthErrors.toError('PROMPT_NONE_NOT_SIGNED_IN');
      }

      return err;
    }
  }, {
    key: "_handlePromptNoneError",
    value: function _handlePromptNoneError(err) {
      return Promise.resolve().then(() => {
        if (err.response_error_code) {
          // Unless the RP overrides this behavior, errors with a `response_error_code`
          // redirect back to the RP with `response_error_code` as the `error` parameter.
          // The override is used by the functional tests to ensure the expected error
          // case is being invoked when checking whether prompt=none can be used.
          return this.redirectWithErrorCode(err);
        } // All other errors are handled at a higher level. If
        // the error should be displayed as a 400 to the user,
        // add the error to the list in error-utils.js, otherwise
        // the error will be displayed as a 500.


        throw err;
      });
    }
  }]);

  return AuthorizationView;
}(BaseView);

Cocktail.mixin(AuthorizationView, ErrorRedirectMixin, SignInMixin);
export default AuthorizationView;